import { Link } from '@mui/material';
import { PropsWithChildren } from 'react';

export const InlineAnchor = ({
  children,
  onClick,
}: PropsWithChildren<{ onClick: () => unknown }>) => {
  if (onClick) {
    return (
      <Link onClick={onClick} underline="none" sx={{ '&:hover': { cursor: 'pointer' }}}>
        {children}
      </Link>
    );
  } else {
    return <>{children}</>;
  }
};
